import { Component } from '@angular/core';
import { NavServiceService } from 'src/app/services/nav-service.service';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss']
})
export class InventoryComponent {
  pageTitle: any = '';

  constructor(
    public navService: NavServiceService
  ){}

  ngOnInit(){
    this.navService.titleSub.subscribe(res => {
      // console.log(res);
      this.pageTitle = res;
    })
  }
}
